export class App {
    router;

    constructor() { }

    configureRouter(config, router) {
        this.router = router;
        config.title = 'Shiloh Consulting';
        config.map([
            {
                route: '',
                name: 'home',
                title: 'Home',
                moduleId: './home',
                nav: true
            },
            {
                route: 'projects',
                name: 'projects',
                title: 'Projects',
                moduleId: './projects',
                nav: true
            },
            {
                route: 'contact-us',
                name: 'contact-us',
                title: 'Contact Us',
                moduleId: './contact-us',
                nav: true
            }
        ]);
    }
}
